export default __webpack_public_path__ + "static/media/kitchenCollection.18cc786a.jpg";